import VueRouter, { RawLocation, Route } from 'vue-router';
import { VueConstructor } from 'vue';
import { ErrorHandler } from 'vue-router/types/router';
import { CoreOptions } from '../../index';
import _ from '../../utils';
import RouterUtils from './routerUtils';
import RouterHistory from './history';

declare module 'vue/types/vue' {
  interface Vue {
    $routerUtils: RouterUtils
  }
  interface VueConstructor {
    $router: VueRouter
    $routerUtils: RouterUtils
  }
}
declare module 'vue-router' {
  export default interface VueRouter {
    history: RouterHistory,
  }
}

export default {
  install(Vue: VueConstructor, options: CoreOptions) {
    const originalPush = VueRouter.prototype.push;
    VueRouter.prototype.push = async function push(to: RawLocation, onComplete?: (route: Route) => void, onAbort?: ErrorHandler): Promise<Route> {
      if (onComplete || onAbort) return (originalPush.call(this, to, onComplete, onAbort) as any);
      try {
        const res: any = await originalPush.call(this, to);
        return res;
      } catch (err) {
        if (VueRouter.isNavigationFailure(err)) {
          Vue.$log.error(err);
          return err.to;
        }
        throw err;
      }
    };

    const originalReplace = VueRouter.prototype.replace;
    VueRouter.prototype.replace = async function replace(to: RawLocation, onComplete?: (route: Route) => void, onAbort?: ErrorHandler): Promise<Route> {
      if (onComplete || onAbort) return (originalReplace.call(this, to, onComplete, onAbort) as any);
      try {
        const res: any = await originalReplace.call(this, to);
        return res;
      } catch (err) {
        if (VueRouter.isNavigationFailure(err)) {
          Vue.$log.error(err);
          return err.to;
        }
        throw err;
      }
    };

    Vue.use(VueRouter);

    let router = options.router as VueRouter;
    if (!(router instanceof VueRouter)) {
      router = new VueRouter({
        ...options.router,
      });
    }
    Vue.$router = router;

    Vue.$routerUtils = new RouterUtils();
    Vue.prototype.$routerUtils = Vue.$routerUtils;
  },
};
